import { Helmet } from 'react-helmet-async';
import Timetable from '../timetable/Timetable';

export default function Agenda() {
	return (
		<>
			<Helmet>
				<title>Agenda - Filmtheater Kriterion Amsterdam</title>
				<meta
					name="description"
					content="Bekijk de complete filmtijden en agenda van Filmtheater Kriterion Amsterdam. Reserveer direct tickets voor alle vertoningen."
				/>
				<link rel="canonical" href="https://www.kriterion.nl/agenda" />
			</Helmet>
			<Timetable />
		</>
	);
}
